const KB = 1024;
const MB = KB * KB;
const GB = MB * KB;

export const getFormattedFileSize = (bytes: number, fixedDigits = 2) => {
	if (bytes <= MB) {
		return `${(bytes / KB).toFixed(fixedDigits)} Kb`;
	} else if (bytes < GB) {
		return `${(bytes / MB).toFixed(fixedDigits)} Mb`;
	} else {
		return `${(bytes / GB).toFixed(fixedDigits)} Gb`;
	}
};